var app = angular.module('leonardo');

var DeviceTypeFilter = function (TaskService) {
  return function (device) {
    var name = 'Invalid type';
    angular.forEach(TaskService.DEVICE_OPTIONS, function(type) {
      if (device == type.id)
        name = type.name;
    });
    return name;
  }
};

app.filter('deviceType', ['TaskService', DeviceTypeFilter]);
